import axios from 'axios'
import { useContext } from 'react'
import { API_BASE_URL_DEV } from '../constants/url'
import { backupRates, backupStates } from '../constants/states'
import { DataContext } from '../context/DataContext'
import { normalizeRegionName, regionIdApi } from '../helpers/addressParser'
import apiInstance from '../helpers/apiInstance'
import { filterPoints, splitPointsByType } from '../helpers/filterPoints'
import { useShopify } from './useShopify'
import {
  companyInfoAvailable,
  isLocalStorageAvailable,
  setCompanyLocalStorage
} from '../helpers/localStorage'
import { getPinflagApiKey, decryptToken } from '../helpers/utils'
import { errorMessage } from '../helpers/bot'
import { ONLY_CHECKOUT } from '../constants/stores'
import { useVtex } from './useVtex'

export const useApiPinflag = () => {
  const {
    cartData,
    setPointsData,
    localPoints,
    setCompanyInfo,
    companyInfo,
    setLoaderInfo
  } = useContext(DataContext)
  const { iframeLoadedShopify, isDifferentLocationKillstore } = useShopify()
  const { getPickupPoints } = useVtex()

  const getCompanyInfo = () => {
    const pinflagApiKey = getPinflagApiKey()
    // getFinalLoaderInfo(pinflagApiKey)
    if (isLocalStorageAvailable()) {
      const companyLocalStorage = companyInfoAvailable(pinflagApiKey)
      if (companyLocalStorage && companyLocalStorage.mapboxToken) {
        const hideCheckout = companyLocalStorage.checkout
        iframeLoadedShopify(!hideCheckout)
        return setCompanyInfo((prevState) => {
          return {
            ...prevState,
            ...companyLocalStorage
          }
        })
      }
    }
    if (pinflagApiKey) {
      apiInstance(pinflagApiKey)
        .get('/company/personalization', {
          cache: {
            maxAge: 5 * 60 * 1000, // override default cache duration for this request
            exclude: { query: false } // don't include query parameters in cache key
          },
          headers: { 'x-api-key': pinflagApiKey }
        })
        .then((res) => {
          iframeLoadedShopify(res.data.checkout)
          let labelPricePickup = res.data.storePickupPriceLabel
          if (!isNaN(parseInt(res.data.storePickupPriceLabel))) labelPricePickup = '$' + res.data.storePickupPriceLabel
          const companyObject = {
            logoUrl: res.data.logoUrl,
            primaryColor: res.data.primaryColor || '#394860',
            secondaryColor: res.data.secondaryColor || '#00B7F9',
            companyName: res.data.company.nombreempresa,
            userId: res.data.company.userId,
            pinflagApiKey,
            ccDiscountPercentageLabel: res.data.ccDiscountPercentageLabel,
            storePickupPriceLabel: labelPricePickup,
            storePickupTypeLabel: res.data.storePickupTypeLabel,
            checkout: res.data.checkout,
            useBillingData: res.data.useBillingData,
            mapboxToken: decryptToken(res.data.mapboxToken, process.env.REACT_APP_TOKEN_ENCRYPTATION_KEY)
          }
          isLocalStorageAvailable() && setCompanyLocalStorage(companyObject)
          return setCompanyInfo((prevState) => {
            return {
              ...prevState,
              ...companyObject
            }
          })
        })
        .catch((err) => {
          setCompanyInfo((prevState) => {
            return {
              ...prevState,
              pinflagApiKey
            }
          })
          console.error(err)
        })
    }
  }

  const getFinalLoaderInfo = (pinflagApiKey) => {
    axios
      .get(`${API_BASE_URL_DEV}/companies/1/personalization/did-you-know`, {
        headers: {
          'x-api-key': '65d2b814-51e7-473a-b8fd-4d88a991cb62'
        }
      })
      .then((res) => {
        setLoaderInfo(res.data)
      })
      .catch((err) => {
        console.error(err)
      })
  }

  const serviceClickAndCollect = async (point) => {
    const { district, stateId, address } = point
    const { pinflagApiKey } = companyInfo
    const { subtotal, totalWeight } = cartData
    const body = {
      address,
      cityName: district,
      stateId,
      price: parseInt(subtotal, 10),
      weight: totalWeight
    }
    try {
      const response = await apiInstance(pinflagApiKey).post('/delivery-cost', body)
      return response.data.services[0]
    } catch (err) {
      body.source = 'CNC'
      errorMessage(err, companyInfo, '/delivery-cost', body)
      return { name: 'Despacho normal' }
    }
  }

  // Hardcode: Killstore Fondos shipping rule (only Bx)
  const checkProductNames = (lines) => {
    const fondo1 = '2,72 x 11'
    const fondo2 = '2,18 x 11'
    return lines.map(line => {
      return line.productName.includes(fondo1.toUpperCase()) || line.productName.includes(fondo2.toUpperCase())
    })
  }

  const calculateShippingPrice = async (
    arrayAddress,
    setData,
    setIsLoading,
    handleConfirmation,
    source,
    setIsComplete
  ) => {
    const [userAddress, district, region] = arrayAddress
    const { subtotal, totalWeight } = cartData
    const { userId, companyName, pinflagApiKey } = companyInfo
    const stateId = parseInt(regionIdApi[normalizeRegionName(region)], 10)
    const differentLocations = companyName === 'Killstore' ? await isDifferentLocationKillstore() : undefined
    const body = {
      cityName: district,
      stateId,
      price: parseInt(subtotal, 10),
      userId,
      weight:
        companyName === 'Safety Store B2B'
          ? 20
          : totalWeight || undefined,
      differentLocations
    }
    if (companyName === 'PinflagtestStore') {
      const products = cartData.lines.map(line => ({
        quantity: line.quantity,
        value: line.singlePrice,
        weight: line.singleWeight,
        description: line.productName
      }))
      Object.assign(body, { products, address: userAddress, shipFromStore: true })
    }
    apiInstance(pinflagApiKey).post('/delivery-cost', body)
      .then((res) => {
        if (Object.keys(res.data).length === 0) {
          setIsComplete(true)
        } else if (res.data.services[0].price === null) {
          setData({
            services: [
              {
                packageDeliveryTime: '2-5 días hábiles',
                price: 3190,
                serviceType: 'standard',
                courier: 'blueexpress'
              }
            ]
          })
        } else {
          if (companyName === 'Killstore') {
            const result = checkProductNames(cartData.lines)
            if (result.some(el => el === true)) {
              const selectedCourier = res.data.services.filter(service => service.courier === 'blueexpress')
              res.data.services = [...selectedCourier]
            }
            res.data.services = res.data.services.map(service => ({ ...service, description: service.packageDeliveryTime }))
          }
          setData(res.data)
        }
        if (res.data.services.length === 1) handleConfirmation(res.data.services[0])
        setIsLoading(false)
      })
      .catch((err) => {
        console.log(err)
        body.source = source
        errorMessage(err, companyInfo, '/delivery-cost', body)
        const backupRate = stateId ? backupRates[stateId] : 3190
        const data = {
          services: [
            {
              packageDeliveryTime: '2-5 días hábiles',
              price: backupRate,
              serviceType: 'standard',
              courier: 'blueexpress'
            }
          ]
        }
        setData(data)
        handleConfirmation(data.services[0])
        setIsLoading(false)
      })
  }

  const getRegions = (setData, setIsLoading) => {
    const { pinflagApiKey } = companyInfo
    apiInstance()
      .get('/states-cities', {
        headers: {
          'x-api-key': pinflagApiKey
        }
      })
      .then((res) => {
        setData(res.data)
        setIsLoading(false)
      })
      .catch((err) => {
        console.log(err, 'error')
        setData(backupStates)
        setIsLoading(false)
      })
  }

  const getPoints = (setIsLoading) => {
    const { subtotal, totalWeight } = cartData
    const price = Number(subtotal)
    const searchParams = new URLSearchParams(document.location.search)
    const pinflagApiKey =
      searchParams.get('token') || process.env.REACT_APP_API_KEY
    if (ONLY_CHECKOUT.includes(companyInfo.companyName)) {
      getPickupPoints(false, setIsLoading)
    } else {
      apiInstance()
        .get(
          `/map?${totalWeight ? 'weight=' + totalWeight + '&' : ''
          }price=${price}`,
          {
            headers: { 'x-api-key': pinflagApiKey }
          }
        )
        .then((res) => {
          const points = filterPoints(res.data.features, localPoints)
          const splitPoints = splitPointsByType(points)
          setPointsData((prevState) => {
            return {
              ...prevState,
              localPoints: splitPoints[0],
              pinflagPoints: splitPoints[1]
            }
          })
          setIsLoading && setIsLoading(false)
        })
        .catch((err) => {
          errorMessage(err, companyInfo, `/map?${totalWeight ? 'weight=' + totalWeight + '&' : ''}price=${price}`)
          setPointsData((prevState) => {
            return {
              ...prevState,
              localPoints: [],
              pinflagPoints: []
            }
          })
          console.log(err)
          setIsLoading && setIsLoading(false)
        })
    }
  }

  return {
    getCompanyInfo,
    calculateShippingPrice,
    getRegions,
    getFinalLoaderInfo,
    getPoints,
    serviceClickAndCollect
  }
}
